// 범용 single-flight 코얼레싱 - 동시에 여러 번 불려도 실제 비동기 작업은 한 번만 진행되고,
// 그 사이에 들어온 호출들은 모두 같은 Promise를 공유한다. 끝나면(성공/실패 모두) 다음 호출은
// 다시 새로 시작한다. client.js의 액세스 토큰 리프레시(여러 요청이 동시에 401을 맞아도
// /api/v1/user/token/refresh는 한 번만 나가야 한다)에 쓴다 - axios와 분리해 순수하게 테스트한다.
export function createSingleFlight(fn) {
  let inFlight = null;

  return function singleFlight(...args) {
    if (!inFlight) {
      inFlight = Promise.resolve()
        .then(() => fn(...args))
        .finally(() => {
          inFlight = null;
        });
    }
    return inFlight;
  };
}

export default createSingleFlight;
